// extracted by mini-css-extract-plugin
export default {"wrap-section":"WrapSection_wrap-section__7Lwsw","wrap-section--black":"WrapSection_wrap-section--black__6KitR","wrap-section--spt":"WrapSection_wrap-section--spt__fEyyT"};